import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';

const GoogleAd = ({type}) => {
    useEffect(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);

	var width, height, adSlot;

	var w = window.innerWidth;
	if(type == "top") {
		if(w >= 900) {
			width = "728px";
            height = "90px";
            adSlot = "9393797729";
        } else {
            width = "320px";
            height = "50px";
            adSlot = "3823473513";
        }
	}
	if(type == "bottom") {
		if(w >= 900) {
			width = "300px";
            height = "250px";
            adSlot = "1816891733";
        } else {
            width = "300px";
            height = "250px";
            adSlot = "4286507941";
        }
	}
	if(type == "tilesetsTop") {
		if(w >= 900) {
			width = "728px";
            height = "90px";
            adSlot = "1080542484";
        } else {
            width = "320px";
            height = "50px";
            adSlot = "6831562617";
        }
	}
	const style = {
        display: 'inline-block',
        width: width,
        height: height
    };

    const containerStyle = {
        textAlign: 'center'
    };

	return (
        <Container style={containerStyle}>
            <span>Advertisement</span><br/>
            <ins className="adsbygoogle"
                style={style}
                data-ad-client="ca-pub-4607955400949460"
                data-ad-slot={adSlot} ></ins>
        </Container>
    );
};

export default GoogleAd;